module.exports = __webpack_public_path__ + "fonts/FreightNeoProBook-Italic.be6240d9.otf";